export async function updateContentsApi({ collection, vertical_id, ids, parent_id, token }) {
  const res = await fetch(`${process.env.REACT_APP_FLASK_WEBSERVER}update_contents`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      collection,
      vertical_id,
      ids,
      parent_id,
    }),
  });

  if (!res.ok) {
    throw new Error('Failed to update content');
  }

  return res.json();
}

export async function updateContentApi({ collection, id, vertical_id, token }) {
  const res = await fetch(`${process.env.REACT_APP_FLASK_WEBSERVER}update_content`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      collection,
      id,
      vertical_id,
    }),
  });

  if (!res.ok) {
    throw new Error('Failed to update content');
  }

  return res.json();
}
